
	export interface FiltroTypes {
		ano?: number,
		mes?: string,
		protocolo?: Array<number>,
		exercicio?: Array<number>,
		cargo?: Array<number>,
		sexo?: string,
		condicionamento?: Array<number>,
		etiqueta?: Array<number>,
		avaliador?: Array<number>,
		articulacao?: Array<number>,
		data?: any
	}

	export function CalcContralaterais(assimetrias_dynalabs:any, filtro: FiltroTypes) {

		if (assimetrias_dynalabs.code === 0) {

			const resultados_contralaterais_por_usuario = assimetrias_dynalabs.assimetrias.map((usuario:any) => {

				//Obtem as execuções
				const exercicios = Object.entries(usuario.LISTAS).map(([key, value]) => (value)).flat();
				let execucoes = exercicios.map((exercicio: any) => exercicio.EXECUCOES).flat();
				//Trás o cargo, sexo, etiquetas e condicionamento para o nível de execucao
				execucoes = execucoes.map((execucao: any) => {execucao.ID_CARGO = usuario.ID_CARGO; return execucao});
				execucoes = execucoes.map((execucao: any) => {execucao.USUARIO_SEXO = usuario.USUARIO_SEXO; return execucao});
				execucoes = execucoes.map((execucao: any) => {execucao.IDS_ETIQUETAS = usuario.IDS_ETIQUETAS; return execucao});
				execucoes = execucoes.map((execucao: any) => {execucao.USUARIO_CONDICIONAMENTO = usuario.USUARIO_CONDICIONAMENTO; return execucao});

				//Filtros 
				execucoes = CalcFilters(execucoes, filtro);

				const legendas = execucoes.map((execucao) => execucao.LEGENDA_ASSIMETRIA)
				const pior_resultado =
					legendas.includes("NEGATIVO_2") ? "NEGATIVO_2" :
						legendas.includes("NEGATIVO_1") ? "NEGATIVO_1" :
							legendas.includes("INTERMEDIARIO") ? "INTERMEDIARIO" :
								legendas.includes("POSITIVO") ? "POSITIVO" : "";

				//Return
				return {
					user: Number(usuario.ID_USUARIO),
					user_nome: usuario.USUARIO_NOME,
					cargo: usuario.ID_CARGO,
					resultados: legendas,
					resultado: pior_resultado,
				};
			})

			const separados = resultados_contralaterais_por_usuario.reduce(
				(acc: any, item: any) => {
					switch (item.resultado) {
						case "NEGATIVO_1":
							acc.negativo_1.push(item);
							break;
						case "NEGATIVO_2":
							acc.negativo_2.push(item);
							break;
						case "INTERMEDIARIO":
							acc.intermediario.push(item);
							break;
						case "POSITIVO":
							acc.positivo.push(item);
							break;
						default:
							break;
					}
					return acc;
				},
				{ negativo_1: [], negativo_2: [], intermediario: [], positivo: [] }
			);

			return ([
				{
					name_risco: "Baixo risco",
					valor_risco: separados.positivo.length,
					fill: "#80F279",
					usuarios: separados.positivo,
				},
				{
					name_risco: "Médio risco",
					valor_risco: separados.intermediario.length,
					fill: "#FFC530",
					usuarios: separados.intermediario,
				},
				{
					name_risco: "Alto risco",
					valor_risco: separados.negativo_1.length,
					fill: "#E57E00",
					usuarios: separados.negativo_1,
				},
				{
					name_risco: "Alto risco 2",
					valor_risco: separados.negativo_2.length,
					fill: "#D12600",
					usuarios: separados.negativo_2,
				},
			]);

		}
	}

	export function CalcAntagonicos(assimetrias_dynalabs:any, filtro:any) {
		if (assimetrias_dynalabs.code === 0) {
			const resultados_antagonicos_por_usuario = assimetrias_dynalabs.assimetrias.map((usuario:any) => {

				if(filtro.sexo && !filtro.sexo.includes(usuario.USUARIO_SEXO)) return false
				const relacoes_referenciais_array = Object.entries(usuario.RELACOES_REFERENCIAIS).map(([key, value]) => ({ key, ...(value as object), }));

				const articulacoes_referencias = relacoes_referenciais_array.map((articulacoes:any) => {
					const articulacoes_REFERENCIAS = articulacoes.REFERENCIAS.map((referencia:any)=> {referencia.key = articulacoes.key; return referencia})
					return articulacoes_REFERENCIAS
				});

				let execucoes = articulacoes_referencias.flat().map((articulacao) => {
					const execucoes = articulacao.EXECUCOES.map((execucao:any)=> {
						execucao.key = articulacao.key;
						return execucao;
					})
					return execucoes;
				}).flat();
			
				execucoes = execucoes.map((execucao: any) => {execucao.ID_CARGO = usuario.ID_CARGO; return execucao});
				execucoes = execucoes.map((execucao: any) => {execucao.USUARIO_SEXO = usuario.USUARIO_SEXO; return execucao});
				execucoes = execucoes.map((execucao: any) => {execucao.IDS_ETIQUETAS = usuario.IDS_ETIQUETAS; return execucao});
				execucoes = execucoes.map((execucao: any) => {execucao.USUARIO_CONDICIONAMENTO = usuario.USUARIO_CONDICIONAMENTO; return execucao});
				execucoes = CalcFilters(execucoes, filtro);
				
				const resultados = execucoes.map((execucao) => {
					return [execucao.RESULTADO_D, execucao.RESULTADO_E];
				});

				const obj_user = { user: usuario.ID_USUARIO, user_nome: usuario.USUARIO_NOME, resultado: "" }
				
				console.log("obj user", obj_user)
				console.log("filtro ", filtro)
				if (resultados.flat().includes("POSITIVO")) {
					obj_user.resultado = "POSITIVO";
				}
				if (resultados.flat().includes("NEGATIVO")) {
					obj_user.resultado = "NEGATIVO";
				}
				if (resultados.flat().includes("S/R")){
					obj_user.resultado = "S/R";
				}

				console.log("obj user_filtrado", obj_user)

				return obj_user

			});

			const separados = resultados_antagonicos_por_usuario.reduce(
				(acc: any, item: any) => {
					switch (item.resultado) {
						case "NEGATIVO":
							acc.negativo.push(item);
							break;
						case "S/R":
							acc.sem_referencia.push(item);
							break;
						case "POSITIVO":
							acc.positivo.push(item);
							break;
						default:
							break;
					}
					return acc;
				},
				{ negativo: [], sem_referencia: [], positivo: [] }
			);

			return ([
				{
					name_risco: "Baixa chance de lesão",
					valor_risco: separados.positivo.length,
					fill: "#80F279",
					usuarios: separados.positivo,
				},
				{
					name_risco: "Há chance de lesão",
					valor_risco: separados.negativo.length,
					fill: "#D12600",
					usuarios: separados.negativo,
				},
				{
					name_risco: "Sem valor de refêrencia",
					valor_risco: separados.sem_referencia.length,
					fill: "#C4C5CC",
					usuarios: separados.sem_referencia,
				},
			]);
		}
	}

	export function CalcCompValoresReferencia(avaliacoes_dynalabs:any, filtro:any) {
		if (avaliacoes_dynalabs.code === 0) {
			const resultados_ref_por_usuarios = avaliacoes_dynalabs.pacientes_avaliados.map((usuario:any) => {
				if(filtro.sexo && !filtro.sexo.includes(usuario.USUARIO_SEXO)) return false
				const protocolos:any = usuario.PROTOCOLOS;
				const avaliacoes = protocolos.map((protocolo:any) => { return protocolo.AVALIACOES }).flat();
				let execucoes = avaliacoes.map((avaliacao:any) => { return avaliacao.EXECUCOES }).flat();

				
				//Trás o cargo, sexo, etiquetas e condicionamento para o nível de execucao
				execucoes = execucoes.map((execucao: any) => {execucao.ID_CARGO = usuario.ID_CARGO; return execucao});
				execucoes = execucoes.map((execucao: any) => {execucao.USUARIO_SEXO = usuario.USUARIO_SEXO; return execucao});
				execucoes = execucoes.map((execucao: any) => {execucao.IDS_ETIQUETAS = usuario.IDS_ETIQUETAS; return execucao});
				execucoes = execucoes.map((execucao: any) => {execucao.USUARIO_CONDICIONAMENTO = usuario.USUARIO_CONDICIONAMENTO; return execucao});
				//Filtros
				execucoes = CalcFilters(execucoes, filtro);

				const evolucoes = execucoes.map((execucao:any) => { return execucao.EVOLUCAO });
				const resultados = evolucoes.map((evolucao:any) => {
					if (evolucao.STATUS == "success") {
						if (evolucao.AVALIACAO == "OK") { return "POSITIVO" } else { return "NEGATIVO" }
					} else {
						return "S/R"
					}
				})

				const obj_user = { user: usuario.ID_USUARIO, user_nome: usuario.USUARIO_NOME, resultado: "" }
				if (resultados.flat().includes("POSITIVO")) {
					obj_user.resultado = "POSITIVO";
				}
				if (resultados.flat().includes("NEGATIVO")) {
					obj_user.resultado = "NEGATIVO";
				} 
				if (resultados.flat().includes("S/R")) {
					obj_user.resultado = "S/R";
				}
				return obj_user

			});

			const separados = resultados_ref_por_usuarios.reduce(
				(acc: any, item: any) => {
					switch (item.resultado) {
						case "NEGATIVO":
							acc.negativo.push(item);
							break;
						case "S/R":
							acc.sem_referencia.push(item);
							break;
						case "POSITIVO":
							acc.positivo.push(item);
							break;
						default:
							break;
					}
					return acc;
				},
				{ negativo: [], sem_referencia: [], positivo: [] }
			);

			return ([
				{
					name_risco: "Dentro do esperado",
					valor_risco: separados.positivo.length,
					fill: "#80F279",
					usuarios: separados.positivo,
				},
				{
					name_risco: "Abaixo do esperado",
					valor_risco: separados.negativo.length,
					fill: "#D12600",
					usuarios: separados.negativo,
				},
				{
					name_risco: "Sem valor de refêrencia",
					valor_risco: separados.sem_referencia.length,
					fill: "#C4C5CC",
					usuarios: separados.sem_referencia,
				},
			]);
		}
	}

	export function CalcAlteracaoParametros(
		indicadores_contralaterais:any,
		indicadores_antagonicos:any,
		comparacao_valores_referencia:any
	) {

		const riscos_contralaterais = indicadores_contralaterais?.map((risco: any) => { return risco })
		const usuarios_contralaterais = riscos_contralaterais.map((risco: any) => { return risco.usuarios }).flat()

		const riscos_antagonicos = indicadores_antagonicos?.map((risco: any) => { return risco })
		const usuarios_antagonicos = riscos_antagonicos.map((risco: any) => { return risco.usuarios }).flat() 

		const riscos_comp_valores_referencia = comparacao_valores_referencia?.map((risco: any) => { return risco })
		const usuarios_comp_valores_referencia = riscos_comp_valores_referencia.map((risco: any) => { return risco.usuarios }).flat()

		const users_compilados = [usuarios_contralaterais, usuarios_antagonicos, usuarios_comp_valores_referencia].flat()

		const users_compilados_estruturados = users_compilados.map(item => ({ ...item, resultado: [item.resultado] }));


		const removido_duplicatas: any = []
		users_compilados_estruturados.map((user) => {
			const index = removido_duplicatas.findIndex((item: any) => Number(item.user) == Number(user.user));
			if (index != -1) {
				removido_duplicatas[index].resultado.push(user.resultado[0])
			} else {
				removido_duplicatas.push(user)
			}
		})

		//Verificar o peso de cada um com base nas regras da doc Indicador de alterações nos parâmetros
		const filtro_pior_resultado = removido_duplicatas.map((user: any) => {
			if (user.resultado.includes("NEGATIVO") || user.resultado.includes("INTERMEDIARIO")) {
				return { ...user, resultado: "NEGATIVO" }
			} else {
				return { ...user, resultado: "POSITIVO" }
			}
		})

		const separados = filtro_pior_resultado.reduce(
			(acc: any, item: any) => {
				switch (item.resultado) {
					case "NEGATIVO":
						acc.negativo.push(item);
						break;
					case "POSITIVO":
						acc.positivo.push(item);
						break;
					default:
						break;
				}
				return acc;
			},
			{ negativo: [], positivo: [] }
		);

		return([
			{
				name_risco: "Padrão esperado",
				valor_risco: separados.positivo.length,
				fill: "#80F279",
				usuarios: separados.positivo,
			},
			{
				name_risco: "Fora do padrão",
				valor_risco: separados.negativo.length,
				fill: "#D12600",
				usuarios: separados.negativo,
			},
		]);


	}

	export function CalcAlteracoesEncontradas(assimetrias_dynalabs:any, filtro:any) {

		function PiorResultado(array_resultados:Array<string>){
			return array_resultados.includes("NEGATIVO_2") ? "NEGATIVO_2" :
							array_resultados.includes("NEGATIVO_1") ? "NEGATIVO_1" :
								array_resultados.includes("INTERMEDIARIO") ? "INTERMEDIARIO" :
									array_resultados.includes("POSITIVO") ? "POSITIVO" : "";
		}

		if (assimetrias_dynalabs.code === 0) {

			const resultados_contralaterais_por_usuario = assimetrias_dynalabs.assimetrias.map((usuario:any) => {

				//Obtem as execuções CONTRALATERAIAS
				const exercicios = Object.entries(usuario.LISTAS).map(([key, value]) => (value)).flat();
				let execucoes = exercicios.map((exercicio: any) => exercicio.EXECUCOES).flat();
				//Trás o cargo, sexo, etiquetas e condicionamento para o nível de execucao
				execucoes = execucoes.map((execucao: any) => {execucao.ID_CARGO = usuario.ID_CARGO; return execucao});
				execucoes = execucoes.map((execucao: any) => {execucao.USUARIO_SEXO = usuario.USUARIO_SEXO; return execucao});
				execucoes = execucoes.map((execucao: any) => {execucao.IDS_ETIQUETAS = usuario.IDS_ETIQUETAS; return execucao});
				execucoes = execucoes.map((execucao: any) => {execucao.USUARIO_CONDICIONAMENTO = usuario.USUARIO_CONDICIONAMENTO; return execucao});

				//Filtros 
				execucoes = CalcFilters(execucoes, filtro);

				const legendas = execucoes.map((execucao) => execucao.LEGENDA_ASSIMETRIA)
				const pior_resultado_contralateral = PiorResultado(legendas)

				
				//Obtem as execucoes I/Q.
				let execucoes_iq = usuario?.RELACOES_REFERENCIAIS?.JOELHO.REFERENCIAS[0]?.EXECUCOES;

				execucoes_iq = execucoes_iq.map((execucao: any) => {execucao.ID_CARGO = usuario.ID_CARGO; return execucao});
				execucoes_iq = execucoes_iq.map((execucao: any) => {execucao.USUARIO_SEXO = usuario.USUARIO_SEXO; return execucao});
				execucoes_iq = execucoes_iq.map((execucao: any) => {execucao.IDS_ETIQUETAS = usuario.IDS_ETIQUETAS; return execucao});
				execucoes_iq = execucoes_iq.map((execucao: any) => {execucao.USUARIO_CONDICIONAMENTO = usuario.USUARIO_CONDICIONAMENTO; return execucao});
				execucoes_iq = CalcFilters(execucoes_iq, filtro);
		
				//Calcula regras IQ
				//Talvez aqui precise mudar e não seja somente o indice zero

				const resultados_iq = [execucoes_iq[0]?.RAZAO_E, execucoes_iq[0]?.RAZAO_D].map((RAZAO: any)=> {
					RAZAO = Number(RAZAO);
					// Alterações graves
					//IQ abaixo de 30% ou acima de 90%
					if( RAZAO <= 30 || RAZAO >= 90){
						return "NEGATIVO_2"
					}
	
					// Significativa
					// Relação IQ entre 30-40 ou 80-90.
					if((RAZAO >= 30 && RAZAO <= 40) || (RAZAO >= 80 && RAZAO <= 90)){
						return "NEGATIVO_1"
					}
	
					// Leve
					//Relação IQ entre 40-50% ou 70-80%
					if((RAZAO >= 40 && RAZAO <= 50) || (RAZAO >= 70 && RAZAO <= 80)){
						return "INTERMEDIARIO"
					}
	
					return "POSITVO"

				})
				const pior_resultado_iq = PiorResultado(resultados_iq);

				const pior_resultado_iq_e_contralateral = PiorResultado([pior_resultado_contralateral, pior_resultado_iq])


				//Return
				return {
					user: Number(usuario.ID_USUARIO),
					user_nome: usuario.USUARIO_NOME,
					cargo: usuario.ID_CARGO,
					resultados: legendas,
					resultado: pior_resultado_iq_e_contralateral,
				};
			})

			const separados = resultados_contralaterais_por_usuario.reduce(
				(acc: any, item: any) => {
					switch (item.resultado) {
						case "NEGATIVO_1":
							acc.negativo_1.push(item);
							break;
						case "NEGATIVO_2":
							acc.negativo_2.push(item);
							break;
						case "INTERMEDIARIO":
							acc.intermediario.push(item);
							break;
						case "POSITIVO":
							acc.positivo.push(item);
							break;
						default:
							break;
					}
					return acc;
				},
				{ negativo_1: [], negativo_2: [], intermediario: [], positivo: [] }
			);

			return ([
				{
					name_risco: "Sem alterações",
					valor_risco: separados.positivo.length,
					fill: "#80F279",
					usuarios: separados.positivo,
				},
				{
					name_risco: "Alterações leves",
					valor_risco: separados.intermediario.length,
					fill: "#FFC530",
					usuarios: separados.intermediario,
				},
				{
					name_risco: "Alterações significativas",
					valor_risco: separados.negativo_1.length,
					fill: "#E57E00",
					usuarios: separados.negativo_1,
				},
				{
					name_risco: "Alterações graves",
					valor_risco: separados.negativo_2.length,
					fill: "#D12600",
					usuarios: separados.negativo_2,
				},
			]);

		}

	}

	function CalcFilters(execucoes:any, filtro:FiltroTypes){
		if (filtro.ano) execucoes = execucoes.filter((execucao:any) => execucao.DATA.includes(filtro.ano));
		if (filtro.mes) execucoes = execucoes.filter((execucao:any) => execucao.DATA.includes(filtro.mes));
		if (filtro.protocolo) execucoes = filtro.protocolo?.map((id_protocolo:number)=> {return execucoes.filter((execucoes:any)=> execucoes.IDS_PROTOCOLOS.includes(id_protocolo.toString()))}).flat();
		if (filtro.exercicio) execucoes = execucoes.filter((execucao:any)=> filtro.exercicio?.includes(Number(execucao.ID_EXERCICIO)));
		if (filtro.cargo) execucoes = execucoes.filter((execucao:any)=> filtro.cargo?.includes(Number(execucao.ID_CARGO)));
		if (filtro.sexo) execucoes = execucoes.filter((execucao:any)=> filtro.sexo?.includes(execucao.USUARIO_SEXO));
		if (filtro.condicionamento) execucoes = execucoes.filter((execucao:any)=> filtro.condicionamento?.includes(Number(execucao.USUARIO_CONDICIONAMENTO)));
		if (filtro.etiqueta) execucoes = filtro.etiqueta?.map((id_etiqueta)=> {return execucoes.filter((execucao:any)=> execucao.IDS_ETIQUETAS?.includes(id_etiqueta.toString()))}).flat();
		if (filtro.avaliador) execucoes = filtro.avaliador?.map((id_avaliador)=> {return execucoes.filter((execucoes:any)=> execucoes.IDS_USUARIOS_AVALIADORES?.includes(id_avaliador.toString()))}).flat();
		if (filtro.articulacao) execucoes = filtro.articulacao?.map((id_articulacao)=> {return execucoes.filter((execucoes:any)=> execucoes.key?.includes(id_articulacao))}).flat();
		if (filtro.data){
			const fromDate = new Date(filtro.data.from);
			const toDate = new Date(filtro.data.to);

			execucoes = execucoes.filter((execucao:any)=> {
			const date = new Date(execucao.DATA);
				if(date>= fromDate && date <= toDate){
					return execucao
				}else{
					return false
				}
			})
		
		}
		return execucoes;
	}